// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"f80fce20","219":"296b4a7c","455":"399606b7","555":"cc2dd1c8","797":"16a6b632","843":"31abda73","852":"efabf713","924":"9b569b09","936":"ac5ae8c7","977":"8c72bf08"}[chunkId] + ".chunk.js";
};